var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapHanger(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E1E1E",
    d: "M0 0h48v47H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2139-795c0-1.104.9-2 2-2h9031c1.1 0 2 .895 2 2v4180c0 1.1-.9 2-2 2h-9031c-1.1 0-2-.9-2-2V-795z",
    fill: "#555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-2137-796h9031v-2h-9031v2zm9032 1v4180h2V-795h-2zm-1 4181h-9031v2h9031v-2zm-9032-1V-795h-2v4180h2zm1 1c-.55 0-1-.45-1-1h-2c0 1.66 1.34 3 3 3v-2zm9032-1c0 .55-.45 1-1 1v2c1.66 0 3-1.34 3-3h-2zm-1-4181c.55 0 1 .448 1 1h2c0-1.657-1.34-3-3-3v2zm-9031-2c-1.66 0-3 1.343-3 3h2c0-.552.45-1 1-1v-2z",
    fill: "#fff",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-2039-695c0-1.105.9-2 2-2H982a2 2 0 012 2V519a2 2 0 01-2 2h-3019c-1.1 0-2-.895-2-2V-695z",
    fill: "#444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-2037-696H982v-2h-3019v2zm3020 1V519h2V-695h-2zm-1 1215h-3019v2H982v-2zm-3020-1V-695h-2V519h2zm1 1c-.55 0-1-.448-1-1h-2c0 1.657 1.34 3 3 3v-2zm3020-1a1 1 0 01-1 1v2a3 3 0 003-3h-2zm-1-1215a1 1 0 011 1h2a3 3 0 00-3-3v2zm-3019-2c-1.66 0-3 1.343-3 3h2c0-.552.45-1 1-1v-2z",
    fill: "#fff",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#swap-hanger_svg__clip0_2001_211)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-992-600H448V424H-992z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "swap-hanger_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-992-500H448v938H-992v-938z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-992-499H448v-2H-992v2zM448 437H-992v2H448v-2z",
    fill: "#E3E1DE",
    mask: "url(#swap-hanger_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-38h416v226H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -7.5,
    width: 47,
    height: 39,
    rx: 5.5,
    stroke: "#948F8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.99 17.21c-2.8 0-3.527-2.226-3.527-5.194 0-2.688.644-5.222 3.528-5.222s3.542 2.534 3.542 5.222c0 2.968-.742 5.194-3.542 5.194zm0-1.176c1.569 0 1.947-1.666 1.947-4.018 0-2.198-.322-4.032-1.946-4.032-1.61 0-1.946 1.848-1.946 4.032 0 2.352.392 4.018 1.946 4.018z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 44.5,
    width: 47,
    height: 39,
    rx: 5.5,
    stroke: "#948F8A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#swap-hanger_svg__filter0_d_2001_211)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#swap-hanger_svg__clip1_2001_211)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-40-600h488V424H-40z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#420022"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.84 1.781a21.6 21.6 0 0114.87 5.912l-6.136-.174-.051 1.534 7.006.194a.768.768 0 00.542-.225.838.838 0 00.225-.562L40.09.994h-1.534l.123 4.582A23.268 23.268 0 003.988 35.634l1.31-.797A21.743 21.743 0 0123.84 1.74v.041zM44.029 11.313l-1.31.808A21.734 21.734 0 019.297 39.306l6.137.174v-1.534l-6.935-.184a.788.788 0 00-.737.481.716.716 0 00-.05.306l.204 7.467H9.45l-.132-4.582a23.278 23.278 0 0034.702-30.07l.01-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.137 15.71a.76.76 0 00-.767.767v2.281l-13.296 7.65a.757.757 0 00-.379.665v3.866a1.35 1.35 0 001.35 1.35H36.87a1.351 1.351 0 001.35-1.35v-3.866a.778.778 0 00-.378-.665l-12.969-7.65v-1.595a3.66 3.66 0 10-4.428-3.58h1.534a2.128 2.128 0 112.127 2.127h.03zm0 4.378l10.544 6.218H13.367l10.77-6.218zM11.27 30.755V27.84h25.457v2.915H11.27z"
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#E3E1DE",
    d: "M-39.5-599.5h487v1023h-487z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "swap-hanger_svg__clip0_2001_211"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-992 -600)",
    d: "M0 0h1440v1024H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "swap-hanger_svg__clip1_2001_211"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-40-600h488V424H-40z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "swap-hanger_svg__filter0_d_2001_211",
    x: -52,
    y: -604,
    width: 504,
    height: 1040,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2001_211"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2001_211",
    result: "shape"
  })))));
}
export default SvgSwapHanger;